import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/phone-toast.png';
const _withScopeId = n => (_pushScopeId("data-v-24e877f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "pc-login"
};
const _hoisted_2 = {
  key: 1,
  class: "mobile-login"
};
const _hoisted_3 = {
  class: "toast-img"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = [_hoisted_4];
import Login from '@/components/login.vue';
import { getOperateSystem } from '@/utils/version.js';
import { computed, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
const __default__ = {
  name: 'HomeView'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const router = useRouter();
    const instance = getCurrentInstance();
    const showToast = ref(false);
    instance?.proxy?.$Bus.on("showToast", status => {
      showToast.value = status;
    });
    instance?.proxy?.$Bus.on("showLoginLoading", status => {
      loading.value = status;
    });
    const isPc = computed(() => {
      if (getOperateSystem() == 'mac' || getOperateSystem() == 'win64' || getOperateSystem() == 'win32') {
        return true;
      } else {
        return false;
      }
    });
    const loading = ref(false);
    const height = window.innerHeight;
    const goPlay = () => {
      if (localStorage.getItem('token')) {
        router.push('/play');
      }
    };
    if (!isPc.value) {
      goPlay();
    }
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(isPc.value ? 'home' : 'home mobile-home'),
        style: _normalizeStyle({
          'height': _unref(height) + 'px'
        })
      }, [isPc.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Login, {
        isPc: isPc.value
      }, null, 8, ["isPc"])])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(Login, {
        isPc: isPc.value
      }, null, 8, ["isPc"])])), _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [[_vShow, showToast.value]])], 6)), [[_directive_loading, loading.value]]);
    };
  }
});